import { NotifyHelper } from "../../../helpers/toast";
import { generateActionForKey, generateActions } from "../generateActions";
import { eDmLoaiThuNhapHocActionsObj } from "./../../action-types/category/IDmLoaiThuNhapHocActions";

export const loaiThuNhapHocActions = {
  ...generateActions(eDmLoaiThuNhapHocActionsObj, "LOAI_THU_NHAP_HOC"),
  ...generateActionForKey(
    eDmLoaiThuNhapHocActionsObj,
    "LOAI_THU_NHAP_HOC",
    "SAVE_SUCCESS",
    () => {
      NotifyHelper.Success("Đã cập nhật");
    }
  ),
  ...generateActionForKey(
    eDmLoaiThuNhapHocActionsObj,
    "LOAI_THU_NHAP_HOC",
    "SAVE_ERROR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
  ...generateActionForKey(
    eDmLoaiThuNhapHocActionsObj,
    "LOAI_THU_NHAP_HOC",
    "DELETE_SUCCESS",
    () => {
      NotifyHelper.Success("Đã xóa");
    }
  ),
  ...generateActionForKey(
    eDmLoaiThuNhapHocActionsObj,
    "LOAI_THU_NHAP_HOC",
    "DELETE_ERROR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
  ...generateActionForKey(
    eDmLoaiThuNhapHocActionsObj,
    "LOAI_THU_NHAP_HOC",
    "DELETE_MANY_SUCCESS",
    () => {
      NotifyHelper.Success("Đã xóa");
    }
  ),
  ...generateActionForKey(
    eDmLoaiThuNhapHocActionsObj,
    "LOAI_THU_NHAP_HOC",
    "DELETE_MANY_ERROR",
    (m: string) => {
      NotifyHelper.Error(m);
    }
  ),
  ...generateActionForKey(
    eDmLoaiThuNhapHocActionsObj,
    "LOAI_THU_NHAP_HOC",
    "SAVE_MULTIPLE_SUCCESS",
    () => {
      NotifyHelper.Success("Thành công");
    }
  ),
  ...generateActionForKey(
    eDmLoaiThuNhapHocActionsObj,
    "LOAI_THU_NHAP_HOC",
    "SAVE_MULTIPLE_ERROR",
    (m: string) => {
      NotifyHelper.Error(m ?? "Thất bại");
    }
  ),
};
